import { Button, Card, Col, Row, Form } from "antd";
import { FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormItem from "antd/es/form/FormItem";
function LoginDevices({ 
    initialValues = {}, 
    updateChangeDevice = () => { }
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  const onFinish = (values) => {
     updateChangeDevice(values);
  };

  return (
    <FormAntd
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}      
    >
      <FormItem shouldUpdate={(prev, cur) => false}>
        {() => (
          <>
            <Row justify="space-between" align="middle">
              <Col>
                <h2 style={{ color: "#313131", fontWeight: 600 }}>
                  {t("configBesmart.login_Devices")}
                </h2>
                <div style={{ color: "#667085" }}>
                  {t("configBesmart.system_Times_Devices_Login")}
                </div>
              </Col>
              <Col>
                <FormSwitch name="LoginDevice" />
              </Col>
            </Row>

            <div style={{ marginTop: 24 }} />

            <Card
              style={{
                border: "1px solid #EAECF0",
                borderRadius: 10,
                background: "#ffffff",
              }}
            >
              <Row
                style={{ padding: 18, borderBottom: "1px solid #F2F4F7" }}
                align="middle"
                justify="space-between"
              >
                <Col>
                  <span style={{ color: "#667085", fontWeight: 600 }}>
                    {t("configBesmart.maximum_Number_Of_Times_To_Change_Equipment")}
                  </span>
                  <div style={{ color: "#A2A1A8" }}>
                    {t(
                      "configBesmart.specify_The_Number_Of_Times_A_User_Can_Switch_Devices_Before_The_System_Login"
                    )}
                  </div>
                </Col>

                <Col>
                  <FormInputNumber
                    name="maximumNumberToChangeDevice"
                    readOnly={true}
                    size="large"
                    placeholder={false}
                    controls={false}
                    width="12vw"
                    precision={0}
                  />
                </Col>
              </Row>
            </Card>

            <Row justify="end" style={{ gap: "12px", marginTop: "16px" }}>
              <Button
                type="default"
                onClick={() => {
                  form.resetFields();
                }}
              >
                {t("common.cancel").toUpperCase()}
              </Button>

              <Button
                type="primary"
                htmlType="submit" // ใช้ submit form
                style={{
                  backgroundColor: "var(--button-color)",
                  color: "white",
                }}
              >
                {t("common.submit").toUpperCase()}
              </Button>
            </Row>
          </>
        )}
      </FormItem>
    </FormAntd>
  );
}

export default LoginDevices;
